// Category configuration types and constants
export const CATEGORY_TYPES = {
  WEDDING: 'wedding',
  HOME_POOJA: 'homePooja',
  FESTIVAL: 'festival',
  LIFE_EVENTS: 'lifeEvents',
  SPIRITUAL: 'spiritual',
  SPECIAL_OCCASIONS: 'specialOccasions'
};

export const CATEGORY_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  COMING_SOON: 'coming_soon',
  MAINTENANCE: 'maintenance'
};

export const CATEGORY_FEATURES = {
  BOOKING: 'booking',
  CUSTOMIZATION: 'customization',
  INSTANT_BOOKING: 'instant_booking',
  CONSULTATION: 'consultation',
  LIVE_STREAMING: 'live_streaming',
  DOCUMENTATION: 'documentation'
};

// Base category configuration interface
export class CategoryConfig {
  constructor({
    id,
    type,
    name,
    displayName,
    description,
    icon,
    image,
    status = CATEGORY_STATUS.ACTIVE,
    features = [],
    metadata = {},
    customization = {}
  }) {
    this.id = id;
    this.type = type;
    this.name = name;
    this.displayName = displayName;
    this.description = description;
    this.icon = icon;
    this.image = image;
    this.status = status;
    this.features = features;
    this.metadata = metadata;
    this.customization = customization;
  }

  // Check if category has specific feature
  hasFeature(feature) {
    return this.features.includes(feature);
  }

  // Check if category is active
  isActive() {
    return this.status === CATEGORY_STATUS.ACTIVE;
  }

  // Get category metadata
  getMetadata(key) {
    return this.metadata[key];
  }

  // Get customization settings
  getCustomization(key) {
    return this.customization[key];
  }
}
